import FormPageFake from '@/components/fakes/formPagesFake';
import { FORM_TEMPLATE_THEMES } from '@/components/fakes/formTemplateFake';

function FormMiMovistarFake() {
  return (
    <FormPageFake
      formTemplateFakes={[
        {
          fakeLength: 4,
        },
        {
          fakeLength: 1,
          formTemplateTheme: FORM_TEMPLATE_THEMES.LONG,
        },
        {
          fakeLength: 2,
        },
        {
          fakeLength: 1,
        },
      ]}
    />
  );
}
export default FormMiMovistarFake;
